import { render } from "./ProducerOrderDeliveryReminder.vue?vue&type=template&id=2776f915"
import script from "./ProducerOrderDeliveryReminder.vue?vue&type=script&lang=js"
export * from "./ProducerOrderDeliveryReminder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__